var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-carousel',{attrs:{"height":"130px","hide-delimiters":"","show-arrows":_vm.media_urls.length > 1}},_vm._l((_vm.media_urls),function(image){return _c('v-carousel-item',{key:image.id,attrs:{"src":image.popup_thumb}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }